import { slugify } from '@/lib/util';
import { useEffect, useState } from 'react';

export default function Checkbox({
  label,
  value,
  tag,
  className,
  onChange,
  filters,
  filterType,
  disabled = false,
}) {
  const labelSlugify = label !== undefined ? slugify(label) : null;

  // Check if this checkbox should be checked by looking for the item in filters
  const isChecked = filters.some((filter) => {
    if (typeof filter === 'object' && filter.value) {
      // If filter is an object, compare by value
      return filter.value === value;
    } else {
      // If filter is a string, compare by value (from URL params or filter state)
      return filter === value;
    }
  });

  // Handle click on custom checkbox to trigger native checkbox
  const handleCustomCheckboxClick = (e) => {
    // Stop propagation to prevent modal from closing
    e.stopPropagation();

    // Don't allow clicks on disabled checkboxes
    if (disabled) return;

    // Create a simple event object that matches what handleFilterChange expects
    const event = {
      target: {
        checked: !isChecked,
        dataset: {
          value: value,
          item: value,
          filterType: filterType,
        },
        type: 'checkbox',
        name: labelSlugify,
        preventDefault: () => {},
      },
      preventDefault: () => {},
      stopPropagation: () => {},
    };

    // Call onChange directly with our event
    onChange(event);
  };

  // Handle native checkbox change to ensure proper event data
  const handleNativeChange = (e) => {
    // Ensure the event has the right dataset values
    e.target.dataset.value = value;
    e.target.dataset.item = value;
    e.target.dataset.filterType = filterType;

    // Call the parent onChange
    onChange(e);
  };

  const Tag = `${tag}`;
  return (
    <Tag className={className} onClick={(e) => e.stopPropagation()}>
      {label && (
        <>
          <div className="flex h-6 items-center">
            <div className="relative">
              <input
                id={labelSlugify}
                aria-describedby={`${labelSlugify}-label`}
                name={labelSlugify}
                type="checkbox"
                className="sr-only" // Hide the native checkbox
                onChange={handleNativeChange}
                checked={isChecked}
                disabled={disabled}
                data-filter-type={filterType}
                data-value={value ? value : null}
                data-item={value ? value : null}
                suppressHydrationWarning
              />
              {/* Custom checkbox */}
              <div
                className={`
                                    w-5 h-5 rounded-xs border-2 transition-all duration-200 ease-in-out
                                    ${
                                      disabled
                                        ? 'bg-gray-100 border-gray-200 cursor-not-allowed opacity-50'
                                        : 'cursor-pointer'
                                    }
                                    ${
                                      isChecked && !disabled
                                        ? 'bg-green-100 border-green-100 shadow-sm'
                                        : !disabled
                                          ? 'bg-white border-brown-100 hover:border-green-100 hover:bg-green-50'
                                          : ''
                                    }
                                `}
                onClick={handleCustomCheckboxClick}
                suppressHydrationWarning
              >
                {/* Checkmark icon */}
                {isChecked && !disabled && (
                  <svg
                    className="w-3 h-3 text-white mx-auto mt-0.5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </div>
            </div>
          </div>
          <div className="ml-3 flex items-center leading-5 text-xs">
            <label
              htmlFor={labelSlugify}
              id={`${labelSlugify}-label`}
              className={`
                                select-none transition-colors duration-150
                                ${
                                  disabled
                                    ? 'text-black/40 cursor-not-allowed'
                                    : 'text-brown-100 hover:text-green-100 cursor-pointer'
                                }
                            `}
              onClick={(e) => e.stopPropagation()}
            >
              {label}
            </label>
          </div>
        </>
      )}
    </Tag>
  );
}
